module.exports = __webpack_public_path__ + "img/mickey17.41db9527.jpg";